import React from "react";
import Herosection from "../component/Herosection"
import ProductsSection from "../component/ProductsSection"
import ProductShowcase from "../component/ProductShowcase"

const HomePage =()=>{

    return(
        <div>
            <Herosection/>
            <ProductShowcase/>
            <ProductsSection/>
        </div>
    )
}

export default HomePage